import { FeedTypeCode } from '@optools/services/operator-gateway/btc/types';
import { MediaFeedType } from '@optools/services/operator-gateway/types/generated/graphql';

export function feedTypeToFeedTypeCode(feedType: MediaFeedType) {
  switch (feedType) {
    case MediaFeedType.AWAY:
      return FeedTypeCode.AD;
    case MediaFeedType.HOME:
      return FeedTypeCode.HD;
    case MediaFeedType.NATIONAL:
      return FeedTypeCode.ND;
    default:
      return FeedTypeCode.UNKNOWN;
  }
}
